import React from 'react';
import { Tooltip } from 'antd';

export const IconWithTooltip: React.FC<{
    title?: React.ReactNode | string,
    tooltipClassName: string,
    iconClassName?: string,
    IconComponent: React.FC<{ className?: string }>
}> =
    ({title, tooltipClassName, IconComponent, iconClassName}) => (
        <Tooltip overlayClassName={`tooltip-wrapper ${tooltipClassName}`} title={title} placement={'bottom'}>
            <IconComponent className={`${iconClassName}`}/>
        </Tooltip>
    );